/**
 * Returns true if the provided value is a string that looks like a conversation
 * ID, i.e. a plain number optionally prefixed with a hash (common notation for
 * conversation IDs in the UI).
 */
export const isMaybeConversationId = (value: string): boolean =>
  /^#?\d+$/.test(value);
